import React, { Component } from 'react';
import PolicyHeader from '../Components/PolicyHeader';
import AmendmentTypeGrid from './Components/AmendmentTypeGrid';
import ManageMembersScreen from './ManageMembers';
import ChangePlanScreen from './ChangePlan';
import ChangeCoverageScreen from './ChangeCoverage';
import ModifyMemberDetailsScreen from './ModifyMemberDetails';
import ManageBenefitsScreen from './ManageBenefits';
import { styles } from '../styles';

class MonamodiAmendment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedAmendment: null
    };
  }

  handleAmendmentSelect = (amendmentId) => {
    this.setState({ selectedAmendment: amendmentId });
  };

  handleBack = () => {
    this.setState({ selectedAmendment: null });
  };

  render() {
    const { policy } = this.props;
    const { selectedAmendment } = this.state;

    // Route to specific amendment screen
    if (selectedAmendment === 'manage-members') {
      return <ManageMembersScreen policy={policy} onBack={this.handleBack} />;
    }

    if (selectedAmendment === 'change-plan') {
      return <ChangePlanScreen policy={policy} onBack={this.handleBack} />;
    }

    if (selectedAmendment === 'change-coverage') {
      return <ChangeCoverageScreen policy={policy} onBack={this.handleBack} />;
    }

    if (selectedAmendment === 'modify-member') {
      return <ModifyMemberDetailsScreen policy={policy} onBack={this.handleBack} />;
    }

    if (selectedAmendment === 'manage-benefits') {
      return <ManageBenefitsScreen policy={policy} onCancel={this.handleBack} onComplete={this.handleBack} />;
    }

    // Show amendment type selection by default
    return (
      <div style={styles.container}>
        <PolicyHeader policy={policy} />
        <AmendmentTypeGrid onAmendmentSelect={this.handleAmendmentSelect} />
      </div>
    );
  }
}

export default MonamodiAmendment;
